/**
 * Дублирование цен в рублях рядом с USD — требование платёжных провайдеров РФ.
 *
 * Курс пока статический. Бэк готовит API курса конвертации; когда появится —
 * заменить константу на значение из API (USD_RUB_RATE читается в одном месте).
 * Ориентир: курс ЦБ РФ на 04.10.2026 — 83,48 ₽; здесь округлено с запасом.
 */
export const USD_RUB_RATE = 85

/** Показывать ли рублёвый эквивалент. Выключить — и везде останется только USD. */
export const SHOW_RUB_EQUIVALENT = true

export function usdToRub(usd: number): number {
  return Math.round(usd * USD_RUB_RATE)
}

/** 810 → «810 ₽», 24300 → «24 300 ₽» */
export function formatRub(rubles: number): string {
  const n = Math.round(rubles)
  try {
    return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n)} ₽`
  } catch {
    return `${n} ₽`
  }
}

/** Рублёвый эквивалент суммы в USD: 9 → «765 ₽». Для других валют — пустая строка. */
export function rubEquivalent(amount: number, currency = 'USD'): string {
  if (!SHOW_RUB_EQUIVALENT || (currency || 'USD').toUpperCase() !== 'USD') return ''
  return formatRub(usdToRub(amount))
}

/** «$9» + «765 ₽» → «$9 / 765 ₽»; если эквивалента нет — исходная строка. */
export function withRub(formatted: string, amount: number, currency = 'USD'): string {
  const rub = rubEquivalent(amount, currency)
  return rub ? `${formatted} / ${rub}` : formatted
}
